import { Modal } from '@cian/ui-kit';
import * as React from 'react';
import { Content } from './parts/Content';
import { ContentHeader } from './parts/ContentHeader';
import { ContentFooter } from './parts/ContentFooter/ContentFooter';
import type { IAiSummaryFooterActions, IAiSummaryResponse } from './types';

const mockSummary: IAiSummaryResponse = {
  title: 'Итоги сравнения от ИИ',
  disclaimer: {
    title: 'Подготовлено на базе описаний ЖК',
    subtitle: 'ИИ может ошибаться — проверяйте важную информацию.',
    actionText: 'Сообщить об ошибке',
  },
  summarization: [
    {
      id: 1,
      name: 'Бадаевский',
      fullUrl: 'https://www.cian.ru/zhiloy-kompleks-badaevskiy-moskva-348843/',
      imageUrl: 'https://images.cdn-cian.ru/images/solos-moskva-jk-2874619442-4.jpg',
      priceRange: '19,36–35,72 млн ₽',
      highlights: {
        title: 'Стоит учесть',
        items: [
          {
            title: 'Срок сдачи — раньше всех',
            subtitle: '2 кв. 2027',
            imagePath: 'functional16Calendar',
          },
          {
            title: 'Расположен ближе всего к центру',
            subtitle: '2 кв. 2027',
            imagePath: 'map16Pin',
          },
          {
            title: 'Расположен ближе всего к центру',
            subtitle: '2 кв. 2027',
            imagePath: 'map16Pin',
          },
          {
            title: 'Расположен ближе всего к центру',
            subtitle: '2 кв. 2027',
            imagePath: 'map16Pin',
          },
          {
            title: 'Расположен ближе всего к центру',
            subtitle: '2 кв. 2027',
            imagePath: 'map16Pin',
          },
        ],
      },
      features: {
        title: 'Особенности ЖК',
        items: [
          { title: 'Концепция «15-минутного города»: сервисы, отдых и работа рядом с домом' },
          { title: 'Концепция «15-минутного города»: сервисы, отдых и работа рядом с домом' },
          { title: 'Концепция «15-минутного города»: сервисы, отдых и работа рядом с домом' },
          { title: 'Концепция «15-минутного города»: сервисы, отдых и работа рядом с домом' },
          { title: 'Концепция «15-минутного города»: сервисы, отдых и работа рядом с домом' },
        ],
      },
    },
    {
      id: 2,
      name: 'Символ',
      fullUrl: 'https://www.cian.ru/zhiloy-kompleks-simvol-moskva-348844/',
      imageUrl: 'https://images.cdn-cian.ru/images/solos-moskva-jk-2874619442-4.jpg',
      highlights: {
        title: 'Стоит учесть',
        items: [
          {
            title: 'Рядом несколько станций метро',
            subtitle: 'До 15 минут пешком',
            imagePath: 'map16Pin',
          },
        ],
      },
    },
    {
      id: 3,
      name: 'River Park',
      fullUrl: 'https://www.cian.ru/zhiloy-kompleks-river-park-moskva-348845/',
      imageUrl: 'https://images.cdn-cian.ru/images/solos-moskva-jk-2874619442-4.jpg',
    },
  ],
  emptyState: {
    title: 'Не хватает данных, чтобы сделать выводы',
    subtitle: 'Позвоните застройщику — он всё расскажет',
    tags: [
      { text: 'В чём особенность ЖК' },
      { text: 'Что по парковкам' },
      { text: 'Акции и скидки' },
      { text: 'Когда достроят дом' },
      { text: 'С какими банками сотрудничает' },
    ],
  },
};

export interface IAiSummaryModalDesktopProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  footerActions: IAiSummaryFooterActions[];
  onCallButtonSlotChange?(newbuildingId: number, slot: HTMLDivElement | null): void;
}

export const AiSummaryModalDesktop = ({
  open,
  onOpenChange,
  footerActions,
  onCallButtonSlotChange,
}: IAiSummaryModalDesktopProps): React.JSX.Element | null => {
  const [activeNewbuildingId, setActiveNewbuildingId] = React.useState(mockSummary.summarization[0].id);
  const activeSummary = mockSummary.summarization.find(item => item.id === activeNewbuildingId);
  const activeFooterActions = footerActions.find(item => item.newbuildingId === activeNewbuildingId);

  if (!activeSummary) {
    return null;
  }

  return (
    <Modal
      onOpenChange={onOpenChange}
      open={open}
      width={640}
      header={
        <ContentHeader
          activeNewbuildingId={activeNewbuildingId}
          items={mockSummary.summarization}
          onSelectNewbuilding={setActiveNewbuildingId}
          title={mockSummary.title}
        />
      }
      title={mockSummary.title}
      body={<Content emptyState={mockSummary.emptyState} summary={activeSummary} />}
      footer={
        <ContentFooter
          actionText={mockSummary.disclaimer.actionText}
          activeNewbuildingId={activeNewbuildingId}
          chat={activeFooterActions?.chat}
          onCallButtonSlotChange={onCallButtonSlotChange}
          subtitle={mockSummary.disclaimer.subtitle}
          title={mockSummary.disclaimer.title}
        />
      }
    />
  );
};
